/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
// Extends from
import Route from '@ember/routing/route';
// Ember imports
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
// External imports
import SnapshotType from '@linc-technologies/linced-common/enums/snapshot-type';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class ReportSnapshotsRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  // Attributes
  @alias('session.activeSchool')
  schoolId;

  @alias('session.school.jurisdiction')
  jurisdiction;

  model() {
    let learner = this.modelFor('people.person').person;
    let data = {
      learner,
      customSnapshots: this.store.query('snapshots/snapshot', {
        schoolId: this.schoolId,
        learnerId: learner.id,
        type: SnapshotType.ON_DEMAND,
      }),
      timeframes: this.store.query('timeframe', {
        schoolId: this.schoolId,
        year: this.dates.currentAcademicYear,
      }),
    };
    // NZ MoE and NSW = bi-annual (semester)
    // UK  = termly
    // Default = termly
    let autoType = SnapshotType.TERMLY; // default
    switch (this.jurisdiction) {
      case Jurisdiction.NZ_MOE:
      case Jurisdiction.AU_NSW:
        autoType = SnapshotType.BIANNUAL;
    }
    data.autoSnapshots = this.store.query('snapshots/snapshot', {
      schoolId: this.schoolId,
      learnerId: learner.id,
      type: autoType,
    });

    return hash(data);
  }

  // `renderTemplate`/`render` were removed in Ember 4.0. `templateName` is
  // the supported way to choose a template; a getter keeps it dynamic.
  get templateName() {
    return this.jurisdiction === Jurisdiction.AU_NSW
      ? 'people/person/report-snapshots/report-snapshots-nsw'
      : 'people/person/report-snapshots/report-snapshots-default';
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.newAutoSnapshots = [];
    controller.newOnDemandSnapshots = [];
  }
}
